import React, { lazy, Suspense } from "react";
// import eruda from "eruda";
import "./App.css";
import { useRoutes } from "react-router-dom";

const ServiceCenter = lazy(() => import("./pages/serviceCenter"));
const FeedbackPage = lazy(() => import("./pages/feedback/index"));
const ListPage = lazy(() => import("./pages/list/index"));
const ListItemContainer = lazy(() => import("./pages/listItemContainer/index"));
const ServiceInfo = lazy(() => import("./pages/serviceInfo"));
const ServiceInfoDetail = lazy(() => import("./pages/serviceInfoDetail"));
const GiftReceive = lazy(() => import("./pages/GiftReceive"));
const ChargePage = lazy(() => import("./pages/ChargePage"));
const ChargePageM = lazy(() => import("./pages/ChargePageM"));
const SuccessPage = lazy(() => import("./pages/SuccessPage"));
const Transform = lazy(() => import("./pages/Transform"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ResultPage = lazy(() => import("./pages/ResultPage"));
const PrivacyInfo = lazy(() => import("./pages/PrivacyInfo"));
// 判断是否为移动设备
const isMobile = window.innerWidth <= 900;

export const routes = [
  {
    path: "/",
    element: <ServiceCenter></ServiceCenter>,
  },
  {
    path: "/feedback",
    element: <FeedbackPage></FeedbackPage>,
  },
  {
    path: "/list",
    element: <ListPage></ListPage>,
  },
  {
    path: "/listItem",
    element: <ListItemContainer></ListItemContainer>,
  },
  {
    path: "/serviceInfo",
    element: <ServiceInfo></ServiceInfo>,
  },
  {
    path: "/serviceInfoDetail",
    element: <ServiceInfoDetail></ServiceInfoDetail>,
  },
  {
    path: "/giftReceive",
    element: <GiftReceive></GiftReceive>,
  },
  {
    path: "/successPage",
    element: <SuccessPage></SuccessPage>,
  },
  {
    path: "/chargePage",
    element: !isMobile ? (
      <ChargePage></ChargePage>
    ) : (
      <ChargePageM></ChargePageM>
    ),
  },
  {
    path: "/transform",
    element: <Transform></Transform>,
  },
  {
    path: "/notFound",
    element: <NotFound></NotFound>,
  },
  {
    path: "/resultPage",
    element: <ResultPage></ResultPage>,
  },
  {
    path: "/privacyInfo",
    element: <PrivacyInfo></PrivacyInfo>,
  },
];

function App() {
  // eruda.init();
  return (
    <Suspense fallback={<div>...Loading</div>}>{useRoutes(routes)}</Suspense>
  );
}

export default App;
